<h1 mat-dialog-title>Choose initial funding</h1>
<div mat-dialog-content class="funding-dialog-content">
  <p class="funding-dialog-copy">
    Fund the initial allowance period now for {{ memberCount }} member{{ memberCount === 1 ? '' : 's' }}.
    Choose a prorated amount through the day before the next scheduled top-up, or the full monthly amount. Exact amounts, fees, and the next payment date appear on the confirmation.
  </p>

  <form class="funding-dialog-form" [formGroup]="form">
    <mat-radio-group
      class="funding-dialog-options"
      formControlName="fundingMode"
    >
      <mat-radio-button color="primary" value="prorated">
        Prorated through the next scheduled top-up
      </mat-radio-button>
      <mat-radio-button color="primary" value="full">
        Full monthly amount per member: {{ fullAmount | currency }}
      </mat-radio-button>
    </mat-radio-group>
  </form>

  <p class="funding-dialog-total" *ngIf="form.get('fundingMode')?.value === 'full'">
    Estimated full allowance funding before fees: {{ previewTotal | currency }}
  </p>
</div>
<div mat-dialog-actions class="funding-dialog-actions">
  <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="save()">
    Continue
  </button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
